import { type FC } from 'react';
import { graphql, type Environment, useFragment } from 'react-relay';

import { SiteNav } from '../SiteNav/SiteNav.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './BottomBar-style.scss';

import { type BottomBar_viewer$key } from './__generated__/BottomBar_viewer.graphql.ts';

type BottomBarProps = {
    viewer: BottomBar_viewer$key;
    userId: string;
    environment: Environment;
};

const BottomBar: FC<BottomBarProps> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment BottomBar_viewer on Viewer {
                ...SiteNav_viewer
            }
        `,
        viewerRef
    );

    return (
        <div className={styles.bar}>
            <div className={styles.barContent}>
                <div
                    className={classnames(dibsCss.flex, dibsCss.justifyEnd, dibsCss.hFull)}
                    data-tn="main-nav-bottom"
                >
                    <SiteNav viewer={viewer} />
                </div>
            </div>
        </div>
    );
};

export default BottomBar;
